export default {
  badInput: 'Deze waarde lijkt onjuist te zijn',
  customError: 'Deze waarde lijkt onjuist te zijn',
  patternMismatch: 'Deze waarde lijkt onjuist te zijn',
  rangeOverflow: 'Deze waarde mag niet groter zijn dan %s',
  rangeUnderflow: 'Deze waarde mag niet lager zijn dan %s',
  stepMismatch: 'Deze waarde voldoet niet aan de stappen',
  tooLong: 'Deze waarde is te lang. Deze mag maximaal %s karakters lang zijn',
  tooShort: 'Deze tekst is te kort. Deze moet uit minimaal %s karakters bestaan',
  typeMismatch: 'Deze waarde lijkt onjuist te zijn',
  valueMissing: 'Dit veld is verplicht',
};
